function oneTrustAutoSlideHandler (slider) {
  // stop autoplay immediately so everything onetrust-related has time to load
  slider.autoplay.stop()

  window.addEventListener('load', () => {
    // some browsers emit the load event before onetrust is loaded but OnetrustActiveGroups always loads
    if (window.OnetrustActiveGroups || window.OneTrust) {
      function checkBanner () {
        const bannerClosed = OneTrust.IsAlertBoxClosed()

        if (!bannerClosed) {
          // if consent is changed while banner is opened -> assume banner is closed
          OneTrust.OnConsentChanged(() => {
            slider.autoplay.start()
          })
          slider.autoplay.stop()
        } else {
          // if banner is closed/doesn't exist, start autoplay after page load
          slider.autoplay.start()
        }
      }

      // wait 100ms for OneTrust to fully load if it hasn't yet, retry indefinitely
      function timeoutBanner () {
        if (window.OneTrust) {
          checkBanner()
        } else {
          setTimeout(() => {
            timeoutBanner()
          }, 100)
        }
      }

      timeoutBanner()
    } else {
      slider.autoplay.start()
    }
  })
}

function getCookie (name) {
  var dc = document.cookie
  var prefix = name + '='
  var begin = dc.indexOf('; ' + prefix)
  if (begin === -1) {
    begin = dc.indexOf(prefix)
    if (begin !== 0) return null
  } else {
    begin += 2
    var end = document.cookie.indexOf(';', begin)
    if (end === -1) {
      end = dc.length
    }
  }
  // because unescape has been deprecated, replaced with decodeURI
  //return unescape(dc.substring(begin + prefix.length, end));
  return decodeURI(dc.substring(begin + prefix.length, end))
}

export default {
  oneTrustAutoSlideHandler
}
